module.exports = __webpack_public_path__ + "img/s6Icon.3179b2b0.svg";